import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Camera } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Loader, EmptyState, DemoTag } from "@/components/kit";

export default function PlateStudio() {
  const nav = useNavigate();
  const [recipes, setRecipes] = useState(null);
  useEffect(() => { api.get("/recipes").then(({ data }) => setRecipes(data.recipes || [])).catch(() => setRecipes([])); }, []);
  if (!recipes) return <Loader />;
  return (
    <div>
      <PageHeader eyebrow="Visual" title="Plate Studio" subtitle="AI plating visuals built from each dish's real ingredients. Open a dish to generate or refine its plate." />
      {recipes.length === 0 ? <EmptyState icon={Camera} title="Nothing to plate yet" body="Generate a menu, then visualize each course here." /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 stagger">
          {recipes.map((r, i) => (
            <button key={i} onClick={() => nav(`/menus/${r.menu_id}`)} data-testid={`plate-card-${i}`} className="matte-card overflow-hidden group text-left">
              <div className="aspect-[4/3] bg-black/50 relative overflow-hidden">
                {r.plating_image ? <img src={r.plating_image} alt={r.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  : <div className="w-full h-full flex flex-col items-center justify-center text-white/25"><Camera size={30} className="mb-2" /><span className="text-xs">Tap to plate</span></div>}
                {r.demo && <div className="absolute top-2 right-2"><DemoTag /></div>}
              </div>
              <div className="p-4">
                <p className="label-eyebrow">{r.course}</p>
                <h3 className="font-serif text-lg mt-1 group-hover:gold-text transition-colors">{r.name}</h3>
                <p className="text-white/40 text-xs mt-1">{r.menu_name}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
